import React from 'react';
import cn from 'classnames';

import { Icons } from '@icons/icons';

import { IButtonWithExtraActionTypes } from './ButtonWithExtraAction.types';

import DynamicIconWrapper from '../DynamicIconWrapper';
import Tooltip from '../Tooltip';

import './ButtonWithExtraAction.scss';

const ButtonWithExtraAction: React.FC<IButtonWithExtraActionTypes> = ({
	label,
	isDisabled,
	disableTooltip,
	onClear,
	onClick,
	count,
}) => {
	const onClickHandler = () => {
		if (isDisabled) return;

		onClick();
	};

	return (
		<div className='f5gButtonWithExtraActionContainer'>
			<Tooltip
				content={disableTooltip}
				isDisabled={!isDisabled || !disableTooltip}
			>
				<div
					className={cn('f5gButtonWithExtraActionMain', {
						f5gButtonWithExtraActionMainDisabled: isDisabled,
					})}
					data-testid='btn-with-extra-action'
					onClick={onClickHandler}
				>
					{label}&nbsp;({count})
				</div>
			</Tooltip>
			<div
				className='f5gButtonWithExtraActionClear'
				onClick={onClear}
			>
				<DynamicIconWrapper icon={Icons.delete} />
			</div>
		</div>
	);
};

export default ButtonWithExtraAction;
